export default __webpack_public_path__ + "static/media/close_round.92e1b9c2.svg";